import { OptionsSource } from '@/types'

/**
 * Resolves options for select fields by handling both array and function-based option sources
 *
 * @param optionsSource - Either an array of options or a function that returns options
 * @param valueOrContext - The current value or context object to pass to the options resolver function
 * @returns An array of options
 */
export const resolveSelectOptions = <T extends Record<string, any>>(
	optionsSource: OptionsSource<T> | undefined,
	valueOrContext?: any,
): T[] => {
	if (typeof optionsSource === 'function') {
		return optionsSource(valueOrContext)
	}
	return optionsSource || []
}
